<template>
  <div class="row content">
    <div class="summary well small col-md-12">
      <table class="col-md-12">
        <thead>
          <tr>
            <td>{{paymentsNoLabel}}</td>
            <td>Total Payment</td>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <td>{{paymentsNoLabel}}</td>
            <td>Total Payment</td>
          </tr>
        </tfoot>
        <tbody>
          <tr>
            <td>{{ model.count }}</td>
            <td>
              <v-money name='total_payment_amount' :currency="model.currencyCode">{{ model.totalAmount }}</v-money>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="clear" />
    </div>
  </div>
</template>

<script>
  /* eslint spec-file: 0 */

  export default {
    name: 'PaymentSnapshot',

    props: {
      model: Object
    },

    computed: {
      paymentsNoLabel() {
        return 'Payment' + (this.model.count !== 1 ? 's' : '')
      }
    }
  }

</script>

<style scoped lang='scss'>
  @import "~@/assets/sass/_variables.scss";
  @mixin soft-font {
    transform: rotate(.03deg); // soften font a bit
  }
  
  .snapshot {
    @include theme {
    }
    &.striped .field {
      &:nth-of-type(odd) {
        @include theme {
          background: v(canvas);
        }
      }
      &.field {
        border: none;
      }
    }
    .field {
      padding-left: 1em;
      padding-right: 1em;
      line-height: 1.5em;
      @include theme {
        border-top: 1px solid v(background);
      }
      &.header {
        @include theme {
          background: v(background-light);
        }
      }
      &.footer-line {
        @include theme {
          border-bottom: 1px solid v(background);
        }
      }
      &.field.footer {
        @include theme {
          background: v(ink);
        }
        .value {
          font-size: $font-size-base-lg;
        }
      }
      label {
        @include soft-font;
        font-size: $font-size-base-sm;
        text-transform: uppercase;
        margin: 0;
      }
      .value {
        @include soft-font;
        display: inline-block;
        font-size: $font-size-base-sm;
        float: right;
      }
    }
  }
  
  // Section cards or containers
  .summary {
    &.well {
      @include theme {
      background: v(canvas);
      border-color: v(background);
      }
      border-radius: 0;
      box-shadow: none;
      padding: .7em 1.5em;
    }
    thead, tfoot {
      font-size: $font-size-xsmall;
    }
    thead {
      display: none;
    }
    tfoot {
      @include theme {
      color: v(background);
      }
    }
    tbody {
      font-weight: $font-weight-bold;
      font-size: $font-size-base-lg;
    }
    td {
      &:first-child {
        padding-left: 0;
      }
      padding-left: 2.33333333%;
    }
  }
  .well {
    border-radius: 0;
    padding-top: .8em;
    padding-bottom: .6em;
    box-shadow: none;
    @include theme {
    border-color: v(background);
    }
    margin-bottom: 10px;

    .expand-icon {
      line-height: 1.7em;
    }

    label {
      @include soft-font;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/Snapshot.vue